import { render, staticRenderFns } from "./ManualOrderTable.vue?vue&type=template&id=2ba25fc2"
import script from "./ManualOrderTable.vue?vue&type=script&lang=ts"
export * from "./ManualOrderTable.vue?vue&type=script&lang=ts"
import style0 from "./ManualOrderTable.vue?vue&type=style&index=0&id=2ba25fc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports